
import Vue, { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    html: {
      type: String,
      default: "<div></div>",
    },
  },
  setup(props) {
    const compiledHtml = computed(() => Vue.compile(`<div>${props.html}</div>`));

    return {
      compiledHtml,
    };
  },
});
